import React from 'react';
import AsideMenuItem from './AsideMenuItem';

function AdminAsideMenu() {
    return (
        <aside>
            <div id="menu-list">
                <AsideMenuItem label="Home" icon={<i className="fas fa-home"></i>} to="/admin/home" />
                <AsideMenuItem label="Accounts" icon={<i className="fas fa-city"></i>} to="/admin/accounts" />
                <AsideMenuItem label="Fees" icon={<i className="fas fa-file-invoice-dollar"></i>} to="/admin/fees" />
                <AsideMenuItem label="Payments" icon={<i className="fas fa-credit-card"></i>} to="/admin/payments" />
                {window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                    <AsideMenuItem label="Import" icon={<i className="fas fa-upload"></i>} to="/admin/import" />
                ) : null}
                {window.env.user.userRoles.some(ur => [1, 3].includes(ur.roleID)) ? (
                    <AsideMenuItem label="Letters" icon={<i className="fas fa-file-invoice"></i>} to="/admin/letters" />
                ) : null}
                {window.env.user.userRoles.some(ur => [1, 2, 3, 4, 5].includes(ur.roleID)) ? (
                    <AsideMenuItem label="Reports" icon={<i className="fas fa-chart-line"></i>} to="/admin/reports" />
                ) : null}
                {window.env.user.userRoles.some(ur => [1].includes(ur.roleID)) ? (
                    <AsideMenuItem label="Administration" icon={<i className="fas fa-unlock-alt"></i>} to="/admin/administration" />
                ) : null}
            </div>
        </aside>
    );
}

export default AdminAsideMenu;